import _ from 'lodash';
import moment from 'moment';
import {
  api, checkForUnauthorized,
} from '@/utils';
import TableHeaderSorting from '../TableHeaderSorting/TableHeaderSorting.vue';

export default {
  name: 'UnlinkedInputOverviewTable',
  components: {
    TableHeaderSorting,
  },
  props: {},
  data: () => ({
    headers: [
      { text: 'Type', value: 'inputType' },
      { text: 'Source', value: 'sourceType' },
      { text: 'Stakeholder name', value: 'sourceStakeholder.name' },
      { text: 'Stakeholder ref.', value: 'sourceStakeholder.reference' },
      { text: 'Client', value: 'clientStakeholder.name' },
      { text: 'Client ref.', value: 'clientStakeholder.reference' },
      { text: 'Vessel imo', value: 'vesselIdentification.vesselImo' },
      { text: 'Begin  time', value: 'dateTimeWindow1.beginEstimate' },
      { text: 'End time', value: 'dateTimeWindow1.endEstimate' },
      { text: 'Created', value: 'createdOn' },
      { text: '', value: 'buttons' },
    ],
    inputs: [],
    stakeholders: [],
    expanded: [],
    snackbar: false,
    snackbarText: String,
    loading: true,
    pageSize: 20,
    page: 1,
    apiVersion: 1,
    orderByField: 'Created',
    orderValue: 'Created',
    orderByDescending: true,
    beginDateMenu: false,
    endDateMenu: false,
    inputTypes: [''],
    sourceTypes: [],
    searchInputs: {
      type: '',
      source: [],
      stakeholder: '',
      stakeholderReference: '',
      client: '',
      clientReference: '',
      vesselImo: '',
      beginTime: null,
      endTime: null,
      created: '',
    },
    client: '',
  }),
  computed: {
    orderBy() {
      return this.orderByDescending ? 'Descending' : 'Ascending';
    },
    changeLoading(b) {
      this.loading = b;
    },
  },
  methods: {
    fetchInputs() {
      this.loading = true;

      // BASEURL
      let url = '/inputs?is-linked=false&';

      // Order by and direction
      url += `order-by-field=${this.orderByField}&order-by=${this.orderBy}`;

      // Page and Pagesize
      url += `&page=${this.page}&page-size=${this.pageSize}`;

      if (this.searchInputs.type !== '') {
        url += `&type=${this.searchInputs.type}`;
      }

      if (this.searchInputs.source.length > 0) {
        url += `&source-types=${this.searchInputs.source}`;
      }

      if (this.searchInputs.stakeholder !== 0) {
        url += `&stakeholder=${this.searchInputs.stakeholder}`;
      }

      if (this.searchInputs.stakeholderReference !== '') {
        url += `&stakeholder-ref=${this.searchInputs.stakeholderReference}`;
      }

      if (this.searchInputs.beginTime !== null) {
        url += `&start=${this.searchInputs.beginTime}`;
      }

      if (this.searchInputs.endTime !== null) {
        url += `&end=${this.searchInputs.endTime}`;
      }

      // Axios.get('https://api.myjson.com/bins/6whvh.json')
      api.get(url)
        .then((response) => {
          if (response.data.length <= 0) {
            this.snackbar = true;
            this.snackbarText = 'No (more) inputs found.';
            if (this.page > 1) {
              this.page -= 1;
            }
          }
          this.inputs = [...this.inputs, ...response.data];
          response.data.forEach((input) => {
            if (!this.inputTypes.includes(input.inputType)) {
              this.inputTypes.push(input.inputType);
            }
            if (!this.sourceTypes.includes(input.sourceType)) {
              this.sourceTypes.push(input.sourceType);
            }
          });
          this.loading = false;
        })
        .catch((error) => {
          checkForUnauthorized(error);
          this.snackbar = true;
          this.snackbarText = `${error.response.status}: ${error.response.statusText}`;
        });
    },
    // eslint-disable-next-line func-names
    fetchSortedInputs: _.throttle(function () {
      this.inputs = [];
      this.page = 1;
      this.fetchInputs();
    }, 1000),
    fetchMoreInputs() {
      this.page += 1;
      this.fetchInputs();
    },
    createNewInput() {
      this.$router.push({ name: 'input-form' });
    },
    goToDetail(item) {
      this.$router.push({ name: 'input-form-with-id', params: { id: item.id } });
    },
    getBeginEstimate(item) {
      if (item.dateTimeWindow1) {
        if (item.dateTimeWindow1.beginActual) {
          const date = moment(item.dateTimeWindow1.beginActual);
          return `${date.format('DD/MM/YYYY hh:mm')} (AT)`;
        }
        if (item.dateTimeWindow1.beginEstimate) {
          const date = moment(item.dateTimeWindow1.beginEstimate);
          return `${date.format('DD/MM/YYYY hh:mm')} (ET)`;
        }
      }
      return '';
    },
    getEndEstimate(item) {
      if (item.dateTimeWindow1) {
        if (item.dateTimeWindow1.endActual) {
          const date = moment(item.dateTimeWindow1.endActual);
          return `${date.format('DD/MM/YYYY hh:mm')} (AT)`;
        }
        if (item.dateTimeWindow1.endEstimate) {
          const date = moment(item.dateTimeWindow1.endEstimate);
          return `${date.format('DD/MM/YYYY hh:mm')} (ET)`;
        }
      }
      return '';
    },
    getCreated(item) {
      const date = moment(item.createdOn);
      return date.format('DD/MM/YYYY hh:mm');
    },
  },
  watch: {
    searchInputs: {
      deep: true,
      handler() {
        this.fetchSortedInputs();
      },
    },
    showDepartedDossiers() {
      this.fetchSortedInputs();
    },
  },
  mounted() {
    this.fetchInputs();
    api.get('/stakeholders?page-size=1000')
      .then((response) => {
        this.stakeholders = [{ id: 0, name: '' }, ...response.data];
      });
  },
};
